import fetch from "cross-fetch"
import React, { useEffect, useState } from "react"
import queryString from "query-string"
import SbEditable from "storyblok-react"

import Loader from "../loader"
import { CareerJobProps, SingleJobDetailProps } from "./partials/CareerJobTypes"
import CareerJobDetails from "./partials/CareerJobDetails"


const CareersJob = ({ blok }: CareerJobProps) => {

  const [jobDetails, setJobDetails] = useState<SingleJobDetailProps | null>(null)

  useEffect(() => {
    const id = queryString.parse(window.location.search).cid

    fetch(`${process.env.GATSBY_CAREERS_DETAILS_API}${id}/`)
      .then((res) => {
        if (res.status >= 400) throw new Error("Bad response from server")

        return res.json()
      })
      .then(job => setJobDetails(job))
      .catch(err => console.error(err))
  }, [])

  return (
    <SbEditable content={blok}>
      {jobDetails ? (
        <CareerJobDetails back_button={blok.back_button} jobDetails={jobDetails} />
      ) : (
        <Loader />
      )}
    </SbEditable>
  )
}


export default CareersJob
